import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Financial Management",
        description: "Streamline financial operations and gain real-time insights into your company’s financial health.",
        imgUrl: "./img/services/business-central/financial-management.jpg",
    },
    {
        title: "Supply Chain Management",
        description: "Manage and optimize your supply chain from procurement to delivery with Business Central.",
        imgUrl: "./img/services/business-central/supply-chain-mangement.jpg",
    },
    {
        title: "Sales and Customer Service",
        description: "Improve customer engagement and manage your sales processes efficiently.",
        imgUrl: "./img/services/business-central/sales-and-customer-services.jpg",
    },
    {
        title: "Project Management",
        description: "Track and manage project costs, timelines, and resources to ensure successful project delivery.",
        imgUrl: "./img/services/business-central/pm.jpg",
    },
    {
        title: "Human Resources",
        description: "Manage employee records, payroll, and other HR tasks to maintain smooth operations.",
        imgUrl: "./img/services/business-central/human-resouce.jpg",
    },
    {
        title: "Business Intelligence",
        description: "Use embedded analytics to gain actionable insights and make data-driven decisions.",
        imgUrl: "./img/services/business-central/bi.jpg",
    },
];

const BusinessCentral = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Business Central Solutions", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Business Central Solutions" description="Empower your business with Business Central’s comprehensive management capabilities for finance, operations, sales, and more." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is Business Central?</h2>
                            <p>
                                Business Central is a comprehensive ERP solution designed for small and medium-sized businesses. It integrates financial management, supply chain management, sales, and other business functions into one unified platform, allowing organizations to streamline processes and gain valuable insights.
                            </p>
                            <img
                                src="./img/services/business-central.png"
                                alt="Business Central Solutions"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Key Features of Business Central</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Business Central</h2>
                            <ul>
                                <li>
                                    <strong>Streamlined Operations:</strong> Integrate your business processes across finance, sales, inventory, and HR for better efficiency.
                                </li>
                                <li>
                                    <strong>Real-Time Insights:</strong> Use embedded analytics and dashboards to track business performance in real-time.
                                </li>
                                <li>
                                    <strong>Scalability:</strong> Grow your business without outgrowing your ERP system, thanks to Business Central’s flexible architecture.
                                </li>
                                <li>
                                    <strong>Cloud-Based Access:</strong> Access Business Central from anywhere with cloud capabilities, enabling remote work and collaboration.
                                </li>
                                <li>
                                    <strong>Improved Decision Making:</strong> Make data-driven decisions using comprehensive business intelligence tools and real-time data.
                                </li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Transform Your Business with Business Central</h2>
                            <p>
                                Unlock the full potential of your business with Business Central’s integrated solution. <br />
                                Get in touch with us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default BusinessCentral;
